import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createAssistantProperties, getMyAssistantProperties, updateAssistantProperties } from '@wix/ambassador-asa-assistant-properties-v1-assistant-properties/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { AssistantPropertiesClientBase } from './AssistantPropertiesClientBase';
export class AssistantPropertiesClient extends HttpBaseClient(AssistantPropertiesClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getMyAssistantProperties", getMyAssistantProperties);
    _defineProperty(this, "createAssistantProperties", createAssistantProperties);
    _defineProperty(this, "updateAssistantProperties", updateAssistantProperties);
  }
}
//# sourceMappingURL=AssistantPropertiesClientHttp.js.map